import * as React from 'react';
import * as _ from 'underscore';
import { getDatasourceInfos } from '../../app/sagas/spaces/SpacesSagaHelpers';
import { Messages } from '../../codegen/Localize';
import { classes } from '../../style';
import { IDataSourceInfo } from '../../ts/models/IDataSourceInfo';
import { PublishFlowSuccessDialogStyles} from '../styles/PublishFlowSuccessDialogStyles';

export interface PublishFlowSuccessDialogProps {
  flowName: string;
  datasourceInfos?: IDataSourceInfo[];
}

export function PublishFlowSuccessDialog(props: PublishFlowSuccessDialogProps) {
  return (
    <div className={PublishFlowSuccessDialogStyles.modal}>
      <div className={classes(PublishFlowSuccessDialogStyles.items)}>
        <span className={PublishFlowSuccessDialogStyles.title}>{Messages.flow()}</span>
        <div className={PublishFlowSuccessDialogStyles.item}>
          <div className={classes(PublishFlowSuccessDialogStyles.icon, PublishFlowSuccessDialogStyles.flowIconResource)}/>
          <div className={PublishFlowSuccessDialogStyles.name}>{props.flowName}</div>
        </div>
        {(props.datasourceInfos && props.datasourceInfos.length > 0) ? renderDatasources(props.datasourceInfos) : null}
      </div>
    </div>
  );
}

function renderDatasources(datasourceInfos: IDataSourceInfo[]) {
  const datasourceElements: JSX.Element[] = _.map(datasourceInfos, (datasourceInfo, index) => {
    return (
      <div className={PublishFlowSuccessDialogStyles.item} key={index}>
        <div className={classes(PublishFlowSuccessDialogStyles.icon, PublishFlowSuccessDialogStyles.datasourceIconResource)}/>
        <div className={PublishFlowSuccessDialogStyles.name}>{datasourceInfo.name}</div>
      </div>
    );
  });

  return (
    <div className={PublishFlowSuccessDialogStyles.datasources}>
      <span className={PublishFlowSuccessDialogStyles.title}>{Messages.pageHeaderDatasources()}</span>
      {datasourceElements}
    </div>
  );
}
